import { makeStyles } from '@fluentui/react-components';
import { tokens } from '@bingads-webui-fluent-component/tokens';

/**
 * Collapse panel V2 overrides shared by Account Details and Payment steps.
 */
export const useV2CollapsePanelOverrides = makeStyles({
  collapsePanelOverrides: {
    '& .collapse-container': {
      gap: '16px',
    },
    '& .collapse-panel, & .fixed-collapse-panel': {
      padding: '0 !important',
      borderRadius: `${tokens.borderRadiusLarge} !important`,
      marginBottom: '0px !important',
      backgroundColor: `${tokens.colorNeutralBackground1} !important`,
      boxShadow: `${tokens.shadow4} !important`,
    },
    '& .collapse-panel .collapse-title-bar, & .fixed-collapse-panel .collapse-title-bar': {
      flexFlow: 'row wrap !important',
      padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalXXL} !important`,
      minHeight: 'unset !important',
    },
    '& .collapse-fixed-panel .collapse-title-bar': {
      paddingBottom: '0 !important',
    },
    '& .collapse-panel .collapse-content, & .fixed-collapse-panel .collapse-content': {
      padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalXXL} !important`,
      marginBottom: '0 !important',
    },
    '& .collapse-panel .collapse-content.content-hide, & .fixed-collapse-panel .collapse-content.content-hide': {
      padding: '0 !important',
    },
  },
});
